import { memo, useEffect } from 'react';

import { ShortUrlObjectType } from '@air/api/types';

import { stopEscKeyPropagationOnAssetDetailsModal } from '~/components/AssetModalV2/hooks/useAssetModalEscKeyHandler';
import { SharePublicItemModal, type SharePublicItemModalProps } from '../SharePublicItemModal';

export type SharePublicClipModalProps = {} & AirModalProps & Omit<SharePublicItemModalProps, 'type'>;

export const SharePublicClipModal = memo((props: SharePublicClipModalProps) => {
  useEffect(() => {
    stopEscKeyPropagationOnAssetDetailsModal(true);
    return () => {
      stopEscKeyPropagationOnAssetDetailsModal(false);
    };
  }, []);

  return <SharePublicItemModal {...props} type={ShortUrlObjectType.clip} />;
});

SharePublicClipModal.displayName = 'SharePublicClipModal';
